var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorite-form",attrs:{"data-toggle":"tooltip","data-placement":"top","title":"加入喜愛產品"}},[_c('button',{class:_vm.favoriteButtonClass,on:{"click":_vm.changeFavorite}})])
}
var staticRenderFns = []

export { render, staticRenderFns }